import EmojiPerfect1 from './EmojiPerfect1';
import EmojiPerfect2 from './EmojiPerfect2';
import EmojiPerfect3 from './EmojiPerfect3';

export { EmojiPerfect1, EmojiPerfect2, EmojiPerfect3 };
